import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    children: React.ReactNode;
    image: React.ReactNode;
    header?: React.ReactNode;
    headerTag?: Parameters<typeof Text>[0]["as"];
    text?: React.ReactNode;
}

export const ResponsiveCardBodyWithImage: React.FC<IProps> = ({image, header, headerTag, text, children}) => (
    <div className={wrapperStyle}>
        {image && <div className={imageColStyle}>{image}</div>}
        <div className={contentStyle}>
            {header && (
                <Text as={headerTag || "h4"} variant="headline_4" className={headerStyle}>
                    {header}
                </Text>
            )}
            {text && <Text variant="body_copy_1">{text}</Text>}
        </div>
        <div className={childrenColStyle}>{children}</div>
    </div>
);

const wrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    flexWrap: "wrap",
    md: {
        alignItems: "center"
    }
});

const imageColStyle = css({
    flex: "0 0 auto",
    fontSize: 0,
    lineHeight: 0,
    md: {
        alignSelf: "stretch"
    }
});

const contentStyle = css({
    flex: "1 1",
    px: 2,
    py: 1,
    _after: {
        display: "block",
        width: "15rem",
        height: 0,
        content: '""'
    }
});

const childrenColStyle = css({
    flex: "0 0 100%",
    alignSelf: "center",
    md: {
        flex: "0 0 auto"
    }
});

const headerStyle = css({
    paddingBottom: 1
});
